export const lineHeights = {
  base: 1.6
};
